import { useContext, useEffect, useState } from 'react'
import RegistrationLayout from '../../Components/RegistrationLayout/RegistrationLayout';
import { useNavigate } from 'react-router-dom';
import Errorgif from '../../Assets/registration-error.gif';
import LoadingTransparent from '../../Components/Loading/LoadingTransparent';
import { RegistrationContext } from '../../Context/RegistrationContext';
import Input from './Input';
import ChevronDown from '../../Assets/Modals/ChevronDown.svg';
import EyeOff from "../../Assets/eyeIconOff.svg";
import Eye from "../../Assets/eye.svg";
import { isValidPhoneNumber, validatePassword, verifyEmail } from '../../lib/utils/utils';
import { apiV1 } from '../../Auth/Interceptor';
import { showToast } from '../../Components/Toaster/Toaster';
import EmailGIF from '../../Assets/email-error.gif';
import XenieLogoDark from "../../Assets/XenieLogoDark.png";

function SectionComponent() {
    const defaultFormInputs = {
        fullName: '',
        phone: '',
        password: '',
        confirmPassword: '',
    }

    const defaultFormErrors = {
        fullName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
    }

    const [showPassword, setShowPassword] = useState(false);

    function toggleShowPassword() {
        setShowPassword(!showPassword);
    }

    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    function toggleShowConfirmPassword() {
        setShowConfirmPassword(!showConfirmPassword);
    }

    const {
        setLoading,
        basicEmail,
        setIsVerifyEmailOpen,
    } = useContext(RegistrationContext);

    const [formInputs, setFormInputs] = useState(defaultFormInputs);
    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    function handleChange(e) {
        const { name, value } = e.target;

        setFormInputs({ ...formInputs, [name]: value });
    }

    async function handleNext() {
        const validationErrors = {}

        if(!formInputs.fullName.trim()) {
            validationErrors.fullName = 'Required field';
        }

        if(!basicEmail.trim()) {
            validationErrors.email = 'Required field';
        }
        else if(!verifyEmail(basicEmail)) {
            validationErrors.email = 'Invalid email address';
        }
        
        if(!formInputs.phone.trim()) {
            validationErrors.phone = 'Required field';
        }
        else if(!isValidPhoneNumber(formInputs.phone)) {
            validationErrors.phone = 'Invalid phone number';
        }
        
        if(!formInputs.password.trim()) {
            validationErrors.password = 'Required field';
        }
        else if(!validatePassword(formInputs.password)) {
            validationErrors.password = 'Must have 8+ characters with upper, lower, number, and special symbol.';
        }

        if(!formInputs.confirmPassword.trim()) {
            validationErrors.confirmPassword = 'Required field';
        }
        else if(formInputs.password !== formInputs.confirmPassword) {
            validationErrors.confirmPassword = 'Passwords don\'t match';
        }

        if(Object.keys(validationErrors).length > 0) {
            setFormErrors(validationErrors);
            return;
        }

        setLoading(true);
        setFormErrors(defaultFormErrors);

        const { confirmPassword, ...data } = formInputs;

        const callData = {
            ...data,
            email: basicEmail
        }

        try {
            const response = await apiV1.post('seller', callData);
            if(response.status === 200) {
                setIsVerifyEmailOpen(true);
            }
            else {
                showToast('Error while registering.', 'error');
                setLoading(false);
            }
        }
        catch(err) {
            showToast('Error while registering.', 'error');
        }
        setLoading(false);
    }

    return (
        <div className='flex flex-col gap-2'>
            <h1 className="font-semibold text-[24px] leading-[44px] text-text1">Basic Information</h1>

            <div className="flex flex-col gap-4 py-3">
                <Input 
                    labelText='Enter Full Name' 
                    errorText={formErrors.fullName} 
                    inputOptions={{
                        type: 'text',
                        id: 'fullName',
                        name: 'fullName',
                        value: formInputs.fullName,
                        onChange: handleChange,
                        placeholder: 'Enter full name'
                    }} 
                />

                <Input 
                    labelText='Enter Address' 
                    errorText={formErrors.email} 
                    inputOptions={{
                        type: 'email',
                        id: 'email',
                        name: 'email',
                        value: basicEmail,
                        placeholder: 'Enter email address',
                        readOnly: true
                    }} 
                />

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label className='select-none cursor-pointer w-fit font-medium text-base text-[#121212]' htmlFor='phone'>Phone Number</label>

                        <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.phone}</p>
                    </div>

                    <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px] flex items-center gap-[10px]">
                        <p className="font-normal text-base text-[#666666]">+91</p>

                        <div className="size-6 flex items-center justify-center">
                            <img src={ChevronDown} alt="" />
                        </div>

                        <input 
                            type='number' 
                            name='phone' 
                            id='phone'   
                            onChange={handleChange} 
                            value={formInputs.phone} 
                            className='bg-transparent outline-none flex-grow' 
                            placeholder='enter phone number' 
                        />
                    </div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label className='select-none cursor-pointer w-fit font-medium text-base text-[#121212]' htmlFor='password'>Password</label>

                        <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.password}</p>
                    </div>

                    <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px] flex items-center gap-[10px]">
                        <input 
                            type={showPassword ? 'text' : 'password'} 
                            name='password' 
                            id='password'   
                            onChange={handleChange} 
                            value={formInputs.password} 
                            className='bg-transparent outline-none flex-grow' 
                            placeholder='enter password' 
                        />

                        <button onClick={toggleShowPassword} className="size-6 flex items-center justify-center">
                            <img src={showPassword ? Eye : EyeOff} alt="" />
                        </button>
                    </div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label className='select-none cursor-pointer w-fit font-medium text-base text-[#121212]' htmlFor='confirmPassword'>Confirm Password</label>

                        <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.confirmPassword}</p>
                    </div>

                    <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px] flex items-center gap-[10px]">
                        <input 
                            type={showConfirmPassword ? 'text' : 'password'} 
                            name='confirmPassword' 
                            id='confirmPassword'   
                            onChange={handleChange} 
                            value={formInputs.confirmPassword} 
                            className='bg-transparent outline-none flex-grow' 
                            placeholder='confirm password' 
                        />

                        <button onClick={toggleShowConfirmPassword} className="size-6 flex items-center justify-center">
                            <img src={showConfirmPassword ? Eye : EyeOff} alt="" />
                        </button>
                    </div>
                </div>
            </div>

            <button onClick={handleNext} className="w-full bg-primaryColor hover:bg-primaryAccent text-white px-3 py-4 rounded-[9px] font-semibold text-[18px] leading-6">Next</button>
        </div>
    )
}

function BasicDetails() {
    const navigate = useNavigate();

    const [isTokenAvailable, setIsTokenAvailable] = useState(true);

    const handleNavigateToForm = () => {
        navigate('/apply-seller');
    }

    const {
        loading,
        setBasicEmail,
        isVerifyEmailOpen,
    } = useContext(RegistrationContext);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");
    
        async function fetchEmail(tokenVal) {
            try {
                const url = `${process.env.REACT_APP_API_URL || ""}v1/verifyInvite/${tokenVal}`;
                const response = await fetch(url);
                if (response.ok) {
                    const data = await response.json();
                    setBasicEmail(data.data.email);
                } else {
                    setIsTokenAvailable(false);
                }
            } catch (err) {
                setIsTokenAvailable(false);
            }
        }
    
        if (token) {
            fetchEmail(token);
        } else {
            setIsTokenAvailable(false);
        }
    }, []);

    return (
        <>
            {loading && <LoadingTransparent />}

            {
                isTokenAvailable ? 
                (
                    isVerifyEmailOpen ?
                    <div className='max-w-screen h-screen flex items-center justify-center pb-16 overflow-y-scroll'>
                        <div className="w-full px-6 h-[36px] fixed top-8 left-8">
                            <img
                                className="w-auto h-full scale-150 max-[1080px]:scale-125" 
                                src={XenieLogoDark}
                                alt="Xenie Logo"
                            />
                        </div>

                        <div className="w-[57%] h-fit p-10 border border-[#EAEAEA] rounded-2xl flex flex-col items-center">
                            <div className="w-[200px] h-[200px] flex items-center justify-center">
                                <img className='w-full h-full' src={EmailGIF} alt="" />
                            </div>

                            <div className="flex flex-col gap-6 items-center">
                                <h1 className='font-semibold text-[32px] leading-[44px] text-[#121212]'>Verify your email address</h1>

                                <p className='font-medium text-base text-[#666666] text-center'>
                                    Check your inbox! We've sent you a verification email. Please click the link inside to confirm your email address and complete the setup. Can't find it? Peek in your spam or promotions folder just in case.
                                </p>
                            </div>
                        </div>
                    </div> : 
                    <RegistrationLayout>
                        <SectionComponent />
                    </RegistrationLayout>
                ) : 
                <div className='max-w-screen h-screen flex justify-center pb-16 overflow-y-scroll'>
                    <div className="mt-[112px] w-[44%] h-fit flex flex-col items-center">
                        <img className="w-[240px] h-[268px]" src={Errorgif} alt=''>
                        </img>

                        <div className="flex flex-col items-center gap-4">
                            <div className="flex flex-col items-center gap-4">
                                <h1 className="font-semibold text-[32px] leading-10 text-[#121212]">Whoops! Not so fast, future seller!</h1>

                                <p className="font-normal text-base text-[#666666] text-center">Before you join our fashionable family, we need to know a bit more about you. Our team is excited to review your application and welcome you to the Hyprcom family</p>
                            </div>

                            <button onClick={handleNavigateToForm} className="font-semibold text-[18px] leading-6 text-buttonText rounded-[9px] px-3 py-4 bg-primaryColor hover:bg-primaryAccent">Apply to Become a Seller</button>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default BasicDetails;
